/* router/index.js 路由配置 */

import { Vue, NProgress } from "@plugins";

// 引入 Vue 路由
import VueRouter from "vue-router";

// 引入 Vuex
import store from "@store";

import { isMobile } from "@utils/index.js";

// 菜单列表
import menu from "@assets/js/menu.js";

Vue.use(VueRouter);

// 动态加载页面
const importPage = (name = "index/index.vue") => {
  if (isMobile()) {
    return () => import(`@pages/${name}`);
  } else {
    return () => import(`@views/${name}`);
  }
};

const Layout = importPage("layout/index.vue");

const getMerchantInfo = () => {
  let storeState = sessionStorage.getItem("jr_shopStore")
    ? JSON.parse(sessionStorage.getItem("jr_shopStore"))
    : store.state || null;

  let merchantInfo =
    storeState && storeState.merchant
      ? storeState.merchant.merchantInfo || []
      : [];

  if (!merchantInfo) {
    getMerchantInfo();
  } else {
    return merchantInfo;
  }
};

var merchantInfo = getMerchantInfo();

const routes = [
  // Error 404 页面
  {
    path: "*",
    name: "Error",
    meta: {
      title: "404 Not Found",
    },
    component: importPage("error/index.vue"),
  },
  // 登录页
  {
    path: "/login",
    name: "Login",
    meta: {
      title: "登录",
    },
    component: importPage("login/index.vue"),
  },
  // 首页
  {
    path: "/",
    name: "Index",
    redirect: "/layout/welcome",
    meta: {
      title: "极壤 - 商家端",
    },
    component: importPage("index/index.vue"),
  },
];

let routerList = store.state.routerList || [];

let menuList = store.state.menuList || [];

const initRouterList = (menuData, level = 1) => {
  // 如果 menuData 不是数组或为空，返回空数组
  if (!menuData || !Array.isArray(menuData)) {
    return [];
  }

  const processRouter = (menuItem, level = 1) => {
    if (!menuItem.isRouter) {
      return null;
    }

    // let isNull = false;

    // if (menuItem.type_id && menuItem.type_id.length) {
    //   //
    //   let typeList = merchantInfo.type_id ? merchantInfo.type_id.split(",") : [];

    //   typeList.forEach((type_id) => {
    //     //
    //     type_id = parseInt(type_id);

    //     if (menuItem.type_id.includes(type_id)) {
    //       if (type_id === 8) {
    //         // 商户
    //         let merchTypeList = merchantInfo.merch_type_id.split(",");

    //         // 转成数字
    //         merchTypeList = merchTypeList.map((item) => parseInt(item));

    //         isNull = !merchTypeList.includes(menuItem.merch_type_id);
    //       } else if (type_id === 9) {
    //         // 门店
    //         if (
    //           menuItem.shop_role === merchantInfo.shop_type ||
    //           menuItem.shop_role.includes(merchantInfo.shop_type)
    //         ) {
    //           isNull = false;
    //         } else {
    //           isNull = true;
    //         }
    //       } else {
    //         isNull = false;
    //       }
    //     } else {
    //       // 跳出循环
    //       isNull = true;
    //     }
    //   });
    // }

    // if (isNull) {
    //   return null;
    // }

    // 路由信息
    const routerInfo = {
      path: menuItem.path,
      name: menuItem.name,
      meta: {
        title: menuItem.title,
        level,
      },
      component: menuItem.isLayout ? Layout : importPage(menuItem.component),
      children: [],
    };

    // 如果存在子级列表
    if (menuItem.children && menuItem.children.length > 0) {
      routerInfo.children = menuItem.children
        .map((children) => processRouter(children, level + 1))
        .filter(Boolean);
    }

    return routerInfo;
  };

  const processMenu = (menuItem, level = 1) => {
    if (!menuItem.isMenu) {
      return null;
    }

    // let isNull = false;

    // if (menuItem.type_id && menuItem.type_id.length) {
    //   //
    //   let typeList = merchantInfo.type_id ? merchantInfo.type_id.split(",") : [];

    //   typeList.forEach((type_id) => {
    //     //
    //     type_id = parseInt(type_id);

    //     if (menuItem.type_id.includes(type_id)) {
    //       if (type_id === 8) {
    //         // 商户
    //         let merchTypeList = merchantInfo.merch_type_id.split(",");

    //         // 转成数字
    //         merchTypeList = merchTypeList.map((item) => parseInt(item));

    //         isNull = !merchTypeList.includes(menuItem.merch_type_id);
    //       } else if (type_id === 9) {
    //         // 门店
    //         if (
    //           menuItem.shop_role === merchantInfo.shop_type ||
    //           menuItem.shop_role.includes(merchantInfo.shop_type)
    //         ) {
    //           isNull = false;
    //         } else {
    //           isNull = true;
    //         }
    //       } else {
    //         isNull = false;
    //       }
    //     } else {
    //       // 跳出循环
    //       isNull = true;
    //     }
    //   });
    // }

    // if (isNull) {
    //   return null;
    // }

    // 路由信息

    const menuInfo = {
      path: menuItem.path,
      name: menuItem.name,
      title: menuItem.title,
      icon: menuItem.icon,
      meta: {
        title: menuItem.title,
        level,
      },
      children: [],
    };

    // 如果存在子级列表
    if (menuItem.children && menuItem.children.length > 0) {
      menuInfo.children = menuItem.children
        .map((children) => processMenu(children, level + 1))
        .filter(Boolean);
    }

    return menuInfo;
  };

  return {
    routerList: menuData
      .map((menuItem) => processRouter(menuItem, level))
      .filter(Boolean),
    menuList: menuData
      .map((menuItem) => processMenu(menuItem, level))
      .filter(Boolean),
  };
};

/* 防止连续点击多次路由报错 */
const routerPush = VueRouter.prototype.push;

const routerReplace = VueRouter.prototype.replace;
// push
VueRouter.prototype.push = function push(location) {
  return routerPush.call(this, location).catch((err) => err);
};
// replace
VueRouter.prototype.replace = function replace(location) {
  return routerReplace.call(this, location).catch((err) => err);
};

if (routerList.length === -1) {
  // 如果路由列表已存在，则直接使用
  routes.push(...routerList);
} else {
  let result = initRouterList(menu);

  // 初始化路由列表
  routerList = result.routerList || [];

  menuList = result.menuList || [];

  // 添加路由列表
  routes.push(...routerList);
}

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

// 路由守卫
router.beforeEach((to, from, next) => {
  // 开启进度条
  NProgress.start();

  // 设置页面标题
  if (to.meta && to.meta.title) {
    document.title = process.env.VUE_APP_TITLE + " - " + to.meta.title;
  }

  if (to.path === "/login") {
    sessionStorage.removeItem("jr_isInit");

    store.commit("setIsInit", false);

    next();
  } else {
    if (!merchantInfo.id) {
      merchantInfo = getMerchantInfo();
    }

    if (merchantInfo.token) {
      next();
    } else {
      sessionStorage.removeItem("jr_isInit");

      store.commit("setIsInit", false);

      next({
        path: "/login",
      });
    }
  }
});

let isInit = store.state.isInit || sessionStorage.getItem("jr_isInit") || false;

// 路由后置守卫
router.afterEach((to, from) => {
  if (!isInit && to.path !== "/login") {
    sessionStorage.setItem("jr_isInit", true);

    store.commit("setIsInit", true);

    location.reload();
  }

  store.commit("setRouterList", routerList);

  store.commit("setMenuList", menuList);

  // 关闭进度条
  NProgress.done();
});

export default router;
